var __jsx = React.createElement;
import React, { useEffect, useRef, useState } from "react";
import { useCMS } from "@hooks/useCMS";
var BanksNewsBar = function BanksNewsBar(_ref) {
  var banks = _ref.banks,
    _ref$speed = _ref.speed,
    speed = _ref$speed === void 0 ? "normal" : _ref$speed,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? "left" : _ref$direction,
    _ref$pauseOnHover = _ref.pauseOnHover,
    pauseOnHover = _ref$pauseOnHover === void 0 ? true : _ref$pauseOnHover;
  var _useCMS = useCMS(),
    imageUrl = _useCMS.imageUrl;
  var containerRef = useRef(null);
  var scrollRef = useRef(null);
  var _useState = useState(false),
    isPaused = _useState[0],
    setIsPaused = _useState[1];
  var animationRef = useRef();

  // Ensure we have banks to display
  if (!banks || banks.length === 0) return null;

  // Calculate speed in pixels per second
  var getScrollSpeed = function getScrollSpeed() {
    switch (speed) {
      case "slow":
        return 30;
      // 30px per second
      case "fast":
        return 100;
      // 100px per second
      default:
        return 60;
      // 60px per second
    }
  };
  var scrollSpeed = getScrollSpeed();
  useEffect(function () {
    var scrollPosition = 0;
    var lastTimestamp = 0;
    var scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    // Get the width of one complete set
    var firstChild = scrollContainer.firstElementChild;
    if (!firstChild) return;
    var contentWidth = firstChild.offsetWidth;
    var _animate = function animate(timestamp) {
      if (!lastTimestamp) lastTimestamp = timestamp;
      var deltaTime = timestamp - lastTimestamp;
      lastTimestamp = timestamp;
      if (!isPaused) {
        // Calculate scroll amount based on time passed
        var scrollAmount = scrollSpeed * deltaTime / 1000;
        if (direction === "left") {
          scrollPosition += scrollAmount;
        } else {
          scrollPosition -= scrollAmount;
        }

        // Reset position when we've scrolled past one complete set
        if (direction === "left" && scrollPosition >= contentWidth) {
          scrollPosition = scrollPosition - contentWidth;
        } else if (direction === "right" && scrollPosition <= -contentWidth) {
          scrollPosition = scrollPosition + contentWidth;
        }

        // Apply the transform
        if (scrollContainer) {
          scrollContainer.style.transform = "translateX(".concat(-scrollPosition, "px)");
        }
      }
      animationRef.current = requestAnimationFrame(_animate);
    };
    animationRef.current = requestAnimationFrame(_animate);
    return function () {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [isPaused, direction, scrollSpeed]);

  // Calculate how many copies we need to fill the viewport
  var viewportWidth = typeof window !== "undefined" ? window.innerWidth : 1920;
  var logoWidth = 150; // Approximate width including gap
  var logosNeeded = Math.ceil(viewportWidth / logoWidth) + banks.length;
  var copies = Math.ceil(logosNeeded / banks.length) + 2;
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full overflow-hidden py-2",
    ref: containerRef,
    onMouseEnter: function onMouseEnter() {
      return pauseOnHover && setIsPaused(true);
    },
    onMouseLeave: function onMouseLeave() {
      return pauseOnHover && setIsPaused(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    ref: scrollRef,
    className: "flex gap-6",
    style: {
      display: "flex",
      willChange: "transform"
    }
  }, Array.from({
    length: copies
  }, function (_, copyIndex) {
    return /*#__PURE__*/React.createElement("div", {
      key: "copy-".concat(copyIndex),
      className: "flex gap-6 flex-shrink-0"
    }, banks.map(function (bank, index) {
      return /*#__PURE__*/React.createElement("div", {
        key: "".concat(copyIndex, "-").concat(index),
        className: "flex-shrink-0"
      }, /*#__PURE__*/React.createElement("img", {
        src: bank === null || bank === void 0 ? void 0 : bank.logo,
        alt: "".concat(bank === null || bank === void 0 ? void 0 : bank.name),
        className: "h-6 md:h-8 w-auto object-contain",
        style: {
          minWidth: "100px"
        },
        loading: "lazy",
        draggable: false
      }));
    }));
  })));
};
export default BanksNewsBar;